module.exports = __webpack_public_path__ + "static/click-tracking-9e606982ca4f660eaf1fe60948c7eb2c.png";